import { AsyncPipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { environment } from '@ecs-environment';
import { TranslatePipe } from '@ngx-translate/core';
import { LanguageService, TrackClickDirective } from '@os-components';
import { SewAdTeaser, SewLink, SewPicture } from '@sew/ui-components-angular/standalone';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Component({
    selector: 'ecs-request-replacement-product',
    templateUrl: './request-replacement-product.component.html',
    styleUrls: ['./request-replacement-product.component.scss'],
    imports: [SewAdTeaser, SewPicture, SewLink, TrackClickDirective, AsyncPipe, TranslatePipe],
})
export class RequestReplacementProductComponent implements OnInit {
    public requestReplacementProductUrl!: Observable<string>;

    public constructor(private languageService: LanguageService) {}

    public ngOnInit(): void {
        this.requestReplacementProductUrl = this.languageService.onLanguageChange.pipe(
            map((language) => this.getRequestReplacementProductUrl(language.toLowerCase()))
        );
    }

    public getRequestReplacementProductUrl(locale: string) {
        return `${environment.baseURLs.api.domain}/${locale}/technical_pages/forwarding/forwarding_contact_form_replacement_product.html?mailbody=`;
    }
}
